import { BuiltinBlockIds } from 'virtual:monospace-builtin-block-ids';
import { defineFieldTypeTemplate } from '#layers/data-model/field-types/define';

export default defineFieldTypeTemplate({
	type: 'primitive',
	id: 'color',
	name: '$t:field_types.color.name',
	description: '$t:field_types.color.description',
	icon: 'lucide:paint-bucket',
	sort: 600,
	keywords: ['hex', 'rgb', 'picker'],
	recommendedDisplay: BuiltinBlockIds.DisplayColorValue,
	supportedPrimitiveTypes: ['string'],
	// TODO allow user to configure presets
});
